// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Data_Money_Rounded.eqMoney);
var productIdIsSymbol = {
    reflectSymbol: function () {
        return "productId";
    }
};
var quantityIsSymbol = {
    reflectSymbol: function () {
        return "quantity";
    }
};
var unitPriceIsSymbol = {
    reflectSymbol: function () {
        return "unitPrice";
    }
};
var ChosenSuggestionIsSymbol = {
    reflectSymbol: function () {
        return "ChosenSuggestion";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var ChosenSuggestion = function (x) {
    return x;
};
var toFillFormTypeChosenSugge = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeChosenSuggestion_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldChosenSuggestion = function (dictHasField) {
    return dictHasField;
};
var eqChosenSuggestion = {
    eq: function (x) {
        return function (y) {
            return eq(x.productId)(y.productId) && x.quantity === y.quantity && eq2(x.unitPrice)(y.unitPrice);
        };
    }
};
var genericChosenSuggestion = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showChosenSuggestion = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericChosenSuggestion)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(productIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(quantityIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(unitPriceIsSymbol)(Data_Money_Rounded.showMoney))(Data_Show.showInt))(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))))(ChosenSuggestionIsSymbol))
};
var unscrambleDecodeChosenSuggestion = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericChosenSuggestion)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(productIdIsSymbol)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(/* #__PURE__ */ Unscramble.decodeRecordCons(quantityIsSymbol)(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons(unitPriceIsSymbol)(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var encodeChosenSuggestion = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericChosenSuggestion)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ChosenSuggestionIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(unitPriceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))(quantityIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))(productIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))))
};
var decodeChosenSuggestion = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericChosenSuggestion)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ChosenSuggestionIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(unitPriceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())(quantityIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())(productIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    ChosenSuggestion,
    genericChosenSuggestion,
    eqChosenSuggestion,
    showChosenSuggestion,
    encodeChosenSuggestion,
    decodeChosenSuggestion,
    unscrambleDecodeChosenSuggestion,
    toFillFormTypeChosenSugge,
    hasFieldChosenSuggestion,
    newtypeChosenSuggestion_
};
